import { JobGroups , JobGroupsAdd , JobGroupsEdit } from "./job-groups";
import { Job , JobAdd , JobEdit } from "./job";
import { Operations , OperationsAdd , OperationsEdit } from "./operations";
import {VcationReasons , VcationReasonsAdd , VcationReasonsEdit} from './vacation-reasons'
import { DelayReasons , DelayReasonsAdd , DelayReasonsEdit } from "./delay-reasons";
import { Holidays , HolidaysEdit , HolidaysAdd } from "./holidays";
import { SchedulesAdd , Schedules , SchedulesEdit } from "./schedules";
import {AccessLevel , AccessLevelAdd , AccessLevelEdit} from './access-level'
import { Admin , AdminAdd , AdminEdit } from "./admin";

export {
    JobGroups , JobGroupsAdd  , JobGroupsEdit,
    Job , JobAdd , JobEdit ,
    Operations , OperationsAdd , OperationsEdit ,
    VcationReasons , VcationReasonsAdd , VcationReasonsEdit ,
    DelayReasons , DelayReasonsAdd , DelayReasonsEdit,
    Holidays , HolidaysEdit , HolidaysAdd ,
    SchedulesAdd , Schedules ,SchedulesEdit ,
    AccessLevel , AccessLevelAdd , AccessLevelEdit  ,
    Admin , AdminAdd , AdminEdit
} ;